import get from 'lodash/get';
import { canUseDOM } from 'exenv';
import URL from 'url-parse';
import * as jwVideoActions from '../../action_creators/video/jw_video_action_creators';
import JwVideoModel from '../../../models/video/jw_video_model';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';
import log from '../../../services/logger_service';
import redirectPostActionCreator from '../../action_creators/redirect_action_creators';

export default function fetchJwVideoDetail(params, store) {
  return function firstDispatch(dispatch) {
    const state = store.getState();
    dispatch(jwVideoActions.jwVideoLoading({}, store));
    return JwVideoModel.fetch(params, store)
      .then(function handleJwVideoDetailData(JwVideoData) {
        const currentUrl = get(state, 'config.navHistory[0]');
        const postLink = get(JwVideoData, 'data.playlist[0].link');
        if (!canUseDOM && postLink) {
          if (currentUrl !== postLink) {
            const parsedCurrent = new URL(currentUrl).pathname;
            const parsedPostLink = new URL(postLink).pathname;
            if (parsedCurrent !== parsedPostLink) {
              dispatch(
                redirectPostActionCreator({
                  status: 301,
                  redirect: postLink
                })
              );
            }
          }
        }
        dispatch(jwVideoActions.jwVideoLoaded(JwVideoData.data, store));
      })
      .catch(function handleUserError(err) {
        const status = get(err, 'response.status.code') || 500;

        if (status === 404 || status === 401) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        }

        if (status === 500) {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
        }

        dispatch(jwVideoActions.jwVideoLoadError(err, store));

        log.error(err, `Error in jwVideo actions, message: ${err.message}`);
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/video/async_jw_video_actions.js